// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Admin_main__1nfXa{\n    /* height: 100vh; */\n    background-color: #d7dde4;\n    text-align: left !important;\n    color: black;\n}", "",{"version":3,"sources":["webpack://src/components/Admin/Admin.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,2BAA2B;IAC3B,YAAY;AAChB","sourcesContent":[".main{\n    /* height: 100vh; */\n    background-color: #d7dde4;\n    text-align: left !important;\n    color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": "Admin_main__1nfXa"
};
export default ___CSS_LOADER_EXPORT___;
